import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Masthead, { MastheadLink, MastheadTitle } from "@amzn/meridian/masthead";
import Link from "@amzn/meridian/link";
import logo from "src/images/logo.svg";
import { CPT_AUDITOR_LDAP_GROUP } from "src/constants";
import { useAppSelector } from "src/store/store";

const header = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const { ldap } = useAppSelector((state) => state.user);

  return (
    <Masthead>
      <MastheadTitle>
        <img src={logo} onClick={() => navigate("/")} width="400" height="60" />
      </MastheadTitle>
      <MastheadLink
        onClick={() => navigate("/dataExtraction")}
        selected={location.pathname.includes("/dataExtraction")}
        data-cy={"data-extraction__tab"}
      >
        Data Extraction
      </MastheadLink>
      <MastheadLink
        onClick={() => navigate("/modelManagement")}
        selected={location.pathname.includes("/modelManagement")}
        data-cy={"model-detail-management__tab"}
      >
        Model Detail Management
      </MastheadLink>
      <MastheadLink
        onClick={() => navigate("/batchProcess")}
        selected={location.pathname.includes("batchProcess")}
        data-cy={"batch-process__tab"}
      >
        Batch process
      </MastheadLink>
      <MastheadLink
        onClick={() => navigate("/validationWorkflow")}
        selected={location.pathname.includes("validationWorkflow")}
        data-cy={"validation-workflow__tab"}
      >
        Validation Workflow
      </MastheadLink>
      {ldap.includes(CPT_AUDITOR_LDAP_GROUP) && (
        <MastheadLink
          onClick={() => navigate("/audit")}
          selected={location.pathname.includes("/audit")}
          data-cy={"audit-workflow__tab"}
        >
          Audit Workflow
        </MastheadLink>
      )}
      <Link
        href={"https://amazon.enterprise.slack.com/archives/C077E6TGH32"}
        target="_blank"
        rel="noopener noreferrer"
        type="secondary"
      >
        Submit Issue
      </Link>
    </Masthead>
  );
};
export default header;
